import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useApp } from '../../context/AppContext';
import { CheckCircle, XCircle } from 'lucide-react';
import './Toast.css';

function ToastItem({ toast }) {
  const { dispatch } = useApp();
  useEffect(() => {
    const t = setTimeout(() => dispatch({ type: 'REMOVE_TOAST', payload: { id: toast.id } }), 3800);
    return () => clearTimeout(t);
  }, [toast.id, dispatch]);

  return (
    <div className={`toast toast-${toast.type}`}>
      {toast.type === 'success' ? <CheckCircle size={15} /> : <XCircle size={15} />}
      <span>{toast.msg}</span>
    </div>
  );
}

export default function ToastContainer() {
  const { state } = useApp();
  return createPortal(
    <div className="toast-container">
      {state.toasts.map(t => <ToastItem key={t.id} toast={t} />)}
    </div>,
    document.body
  );
}
